
<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  name: "cost-breakdown-comparison-chart",

  props: [ 'series' ],

  watch: {
    series: function() {
      this.render()
    }
  },

  computed: {
    leaseSeries() {
      return this.series.map(o => o.costs.realEstateCost)
    },
    laborSeries() {
      return this.series.map(o => o.costs.laborCost)
    },
    inboundTransportationSeries() {
      return this.series.map(o => o.costs.inboundTransportationCost)
    },
    outboundTransportationSeries() {
      return this.series.map(o => o.costs.outboundTransportationCost)
    },
    
  },

  mounted () {
    this.render()
  },

  methods: {
    render() {
      this.renderChart({
        labels: this.series.map(o => o.name),
        datasets: [
          {
            label: 'Outbound Transportation',
            data: this.outboundTransportationSeries,
            backgroundColor: '#4471C3'
          }, {
            label: 'Inbound Transportation',
            data: this.inboundTransportationSeries,
            backgroundColor: '#9DC2E5'
          }, { 
            label: 'Labor',
            data: this.laborSeries,
            backgroundColor: '#A5A5A5'
          }, {
            label: 'Lease',
            data: this.leaseSeries,
            backgroundColor: '#FCBF01'
          }
        ]}, {
          legend: {
            display: true
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem) {
                return Number(tooltipItem.yLabel * 100).toFixed(1).replace(/./g, function(c) {
                  return c
                }) + "%"
              }
            }
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              stacked: true,
              ticks: {
                suggestedMin: 0,
                userCallback: function(value) {
                  value = value.toString();
                  value = value.split(/(?=(?:...)*$)/);
                  value = value.join(',');
                  return `${value * 100}%`
                }
              },
              scaleLabel: {
                display: true,
                labelString: 'Percentage of Whole',
                fontColor: '#999',
              }
            }],
            xAxes: [{
              stacked: true,
              scaleLabel: {
                display: false,
                labelString: 'Expense Categories',
                fontColor: '#999'
              }
            }]

          }
        }
      )      
    }
  }
}

</script>